import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { User, Mail, LogOut } from 'lucide-react';

export const ProfilePage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-muted-foreground mb-4">Please login to view your profile</p>
          <Button onClick={() => navigate('/login')} className="rounded-full">
            Login
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-8" data-testid="profile-page">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-outfit font-semibold text-3xl md:text-4xl mb-8" data-testid="profile-heading">
          My Profile
        </h1>

        <div className="bg-white rounded-lg border border-border p-8 space-y-6">
          <div className="flex items-center gap-4 pb-6 border-b border-border">
            <div className="w-20 h-20 rounded-full bg-primary flex items-center justify-center">
              <User className="w-10 h-10 text-primary-foreground" />
            </div>
            <div>
              <h2 className="font-semibold text-2xl" data-testid="user-name">{user.name}</h2>
              <p className="text-muted-foreground" data-testid="user-email">{user.email}</p>
            </div>
          </div>

          <div className="space-y-4">
            <div className="flex items-center gap-3 p-4 bg-muted rounded-lg">
              <Mail className="w-5 h-5 text-muted-foreground" />
              <div>
                <p className="text-sm text-muted-foreground">Email</p>
                <p className="font-medium">{user.email}</p>
              </div>
            </div>

            <div className="flex items-center gap-3 p-4 bg-muted rounded-lg">
              <User className="w-5 h-5 text-muted-foreground" />
              <div>
                <p className="text-sm text-muted-foreground">Name</p>
                <p className="font-medium">{user.name}</p>
              </div>
            </div>
          </div>

          <div className="pt-6 border-t border-border space-y-3">
            <Button
              onClick={() => navigate('/orders')}
              variant="outline"
              className="w-full rounded-full"
              data-testid="view-orders-button"
            >
              View Orders
            </Button>
            <Button
              onClick={() => navigate('/wishlist')}
              variant="outline"
              className="w-full rounded-full"
              data-testid="view-wishlist-button"
            >
              View Wishlist
            </Button>
            <Button
              onClick={handleLogout}
              variant="destructive"
              className="w-full rounded-full"
              data-testid="logout-button"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
